import { siteInfo } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section id="hero" className="relative min-h-[600px] lg:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/30"></div>
      <div className="absolute top-0 right-0 w-full lg:w-[55%] h-full opacity-20 lg:opacity-100">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dramatic%20warm%20atmosphere%20with%20flowing%20fabric%20textures%2C%20crimson%20and%20golden%20gradients%2C%20stage%20curtain%20concept%2C%20mysterious%20theatrical%20vibe%2C%20soft%20glow%20in%20center%2C%20dark%20edges%2C%20entertainment%20industry%20aesthetic%2C%20no%20text%2C%20no%20people&width=1200&height=800&seq=hero-main&orientation=landscape"
          alt="91黑料吃瓜 - 全网黑料视频聚合平台主视觉"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-50/95 via-background-50/85 to-transparent lg:to-background-50/10"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 lg:py-24">
        <div className="max-w-[1280px] mx-auto">
          <div className="lg:w-[55%]">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-primary-100/80 rounded-full mb-5">
              <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
              <span className="text-xs font-semibold text-primary-700 whitespace-nowrap">实时更新中</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-foreground-950 leading-tight mb-4 font-heading">
              91黑料吃瓜
              <span className="block text-primary-500 text-2xl md:text-3xl lg:text-4xl mt-2">
                {siteInfo.tagline}
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-semibold mb-6">
              {siteInfo.slogan}
            </p>

            <div className="text-sm md:text-base text-foreground-700 leading-relaxed mb-7 max-w-xl">
              {siteInfo.description.split('。').filter(Boolean).map((sentence, i) => (
                <span key={i}>
                  {sentence}。
                  {i === 1 && <br />}
                </span>
              ))}
            </div>

            <div className="flex items-center gap-6 mb-8">
              {siteInfo.stats.map((stat, i) => (
                <div key={i} className="text-center">
                  <div className="text-2xl md:text-3xl font-extrabold text-primary-500">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href={siteInfo.ctaPrimary.href}
                onClick={(e) => handleClick(e, siteInfo.ctaPrimary.href)}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-bold text-base rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-play-circle-line text-lg"></i>
                {siteInfo.ctaPrimary.text}
              </a>
              <a
                href={siteInfo.ctaSecondary.href}
                onClick={(e) => handleClick(e, siteInfo.ctaSecondary.href)}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50 text-foreground-800 font-semibold text-base rounded-lg border border-background-300 hover:border-primary-300 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-send-plane-line text-lg"></i>
                {siteInfo.ctaSecondary.text}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}